import { Component, ElementRef, Input, OnInit } from '@angular/core';

import { environment } from '../../../environments/environment';
import { RequestSnippet, RequestSnippetLang, requestSnippetLangs } from '../../helpers/request-snippet';

import { RequestSnippetService } from '../../services/request-snippet.service';
import { SnippetService } from '../../services/snippet.service';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'kd-document-request',
    templateUrl: './document-request.component.html',
    styleUrls: ['./document-request.component.scss']
})
export class DocumentRequestComponent implements OnInit {

    @Input()
    element: HTMLElement;

    error: string;
    lang: RequestSnippetLang;
    langs: Array<RequestSnippetLang> = requestSnippetLangs;
    private snippet: RequestSnippet;
    spinner = false;
    private topBefore: number = null;

    constructor(
        private elementRef: ElementRef,
        private requestSnippetService: RequestSnippetService,
        private snippetService: SnippetService,
        private userService: UserService,
    ) { }

    ngOnInit() {
        try {
            this.snippet = this.requestSnippetService.parseSnippet(this.element.innerHTML);

            this.initSnippet();
            this.requestSnippetService.getLangChange().subscribe(() => {
                this.initSnippet().then((): void => {
                    this.stopLangChange();
                });
            });

            this.userService.getCredentialsChange().subscribe(() => {
                this.initSnippet();
            });
        } catch (error) {
            this.error = error.message;
        }
    }

    private initSnippet(): Promise<void> {
        const content: string = this.requestSnippetService.buildSnippet(this.snippet);
        this.lang = this.requestSnippetService.getLang();

        return this.snippetService.initSnippet(this.elementRef.nativeElement, '.content', content);
    }

    isLangSelected(lang: RequestSnippetLang): boolean {
        return lang.name === this.lang.name;
    }

    selectLang(lang: RequestSnippetLang): void {
        this.startLangChange();
        this.requestSnippetService.setLang(lang);
    }

    private startLangChange(): void {
        // Save scroll position
        this.topBefore = this.elementRef.nativeElement.getBoundingClientRect().top;
        this.spinner = true;
    }

    private stopLangChange(): void {
        // Move page scroll to the previous position
        if (this.topBefore !== null) {
            const topAfter: number = this.elementRef.nativeElement.getBoundingClientRect().top;
            const scrollContainer: HTMLElement = document.querySelector(environment.scrollContainer);
            scrollContainer.scrollTop += (topAfter - this.topBefore);

            this.topBefore = null;
            setTimeout(() => {
                this.spinner = false;
            }, environment.snippetBackdropDelay);
        }
    }
}
